<template>
    <div class="d-flex align-items-center">
        <div class="row flex-grow-1">
            <div class="col-6 d-flex align-items-center">
                <span class="me-1">Desde:</span>
                <input
                    type="date"
                    v-model="startDate"
                    :min="min"
                    :max="max" 
                    class="form-control form-control-sm"
                />
            </div>

            <div class="col-6 d-flex align-items-center">
                <span class="me-2">Hasta:</span>
                <input
                    type="date"
                    v-model="endDate"
                    :min="min"
                    :max="max"
                    class="form-control form-control-sm"
                />
            </div>
        </div>
        
        <div class="flex-shrink-1 ms-3">
            <button v-on:click="clearFilter" type="button" class="btn btn-outline-danger btn-sm" :disabled="!enableButton">
                Limpiar filtro
            </button>
        </div>
    </div>
</template>

<script>
import { EventNames } from '@/plugins/enums/index.js'

export default {
    name: 'FilterDate',

    data() {
        return {
            min: null,
            max: null,

            startDate: null,
            endDate: null
        }
    },

    computed: {
        enableButton() {
            return this.startDate || this.endDate
        }  
    },

    mounted() {
        this.inicializarValorMaximoParaFiltroFecha();
        this.inicializarValorMinimoParaFiltroFecha();
    },

    methods: {
        filteredItems() {
            this.$eventBus.$emit(EventNames.FilterUsersAfterFilterDate, {
                startDate: this.startDate,
                endDate: this.endDate
            });
        },

        clearFilter() {
            this.startDate = null;
            this.endDate = null;
        },

        inicializarValorMaximoParaFiltroFecha() {
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            // 15th in two months
            const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth() + 2)
            maxDate.setDate(15)
            this.max = maxDate;
        },

        inicializarValorMinimoParaFiltroFecha() {
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth() - 2)
            minDate.setDate(15)
            this.min = minDate;
        }
    },

    watch: {
        'startDate'() {
            this.filteredItems();
        },

        'endDate'() {
            this.filteredItems();
        }
    }

}
</script>
<style scoped>

.my-custom-datepicker {
    /* Añade aquí tus estilos personalizados */
    /* Por ejemplo: */
    border: 1px solid #E1E1E1;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #0073AA;
    background-color: #0073AA;
    background-clip: padding-box;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>